export function assertPresent<T>(value: T | null | undefined): asserts value is T {
  if (value == null) {
    throw new Error('Expected value to be present, but got null or undefined');
  }
}
